import ScDrawer from "@/PageComponents/Drawer/ScDrawer";
import { Flex, LoadingOverlay } from "@mantine/core";
import React, { FC, useEffect, useRef, useState } from "react";
import ManageQuoteForm, { ManageQuoteProps } from "@/PageComponents/Quote/ManageQuoteForm";
import { useQuery } from "@tanstack/react-query";
import Fetch from "@/utils/Fetch";
import { useDidUpdate } from "@mantine/hooks";
const QuoteDrawer: FC<{
    show?: boolean
    onCreated?: (createdQuoteResult: any, close: boolean) => void
    onSaved: (savedQuoteResult: any) => void
    setIsNew: (isNew: boolean) => void
    // onSavedRefreshOnly: (data) => void
} & ManageQuoteProps> = ({ show, ...others }: any) => {

    const [validateAndCloseCounter, setValidateAndClose] = useState(0)

    const [currentQuote, setCurrentQuote] = useState(others.quote)

    const [isNew, setIsNew] = useState(others.isNew)

    useEffect(() => {
        if (!isNew && !currentQuote) {
            setCurrentQuote(others.quote) // it is needed to set the initial quote as this component is not unmounted when not shown.  Current quote is managed in order to allow prompt before updating
        }/* else if(isNew) {
            console.log('attempt to set quote')
            setValidateAndClose(p => p + 1)
        }*/
    }, [others.quote]);

    const { data: quote, isFetching } = useQuery(['quote', currentQuote?.ID], () => Fetch.get({
        url: `/Quote/${currentQuote?.ID}`
    }), {
        enabled: !!currentQuote?.ID && !isNew && show,
        staleTime:0
    })

    const drawerSize = 'clamp(900px, 100vw - 310px, 1320px)'

    const [fullScreen, setFullScreen] = useState(false)

    useEffect(() => {
        if (!show) {
            setCurrentQuote(null)
        }
    }, [show]);

    const [forceRemount, setForceRemount] = useState(false)
    useEffect(() => {
        if (forceRemount) {
            setForceRemount(false)
        }
    }, [forceRemount])
    useDidUpdate(() => {
        setForceRemount(true)
        setIsNew(others.isNew)
        if (others.isNew) {
            setCurrentQuote(null)
        }
    }, [others.isNew]);

    const prevTitleRef = useRef('');
    useEffect(() => {
        if (show) {
            prevTitleRef.current = document.title;
            return () => { document.title = prevTitleRef.current; };
        }
    }, [show]);
    useEffect(() => {
        if (!show) return;
        document.title = isNew
            ? 'Create Quote | Quotes'
            : (currentQuote?.QuoteNumber ? `${currentQuote.QuoteNumber} | Quotes` : 'Quotes | ServCraft');
    }, [show, currentQuote?.QuoteNumber, isNew]);

    return <ScDrawer
        linkToFullPage={!isNew && ('/quote/' + currentQuote?.ID)}
        opened={show || typeof show === 'undefined'}
        onClose={() => {
            // others.onClose()
            (isFetching && others.onClose && others.onClose()) ||
                setValidateAndClose((p: any) => p + 1)
        }}
        title={isNew ? 'Create Quote' :
            <Flex gap={'sm'} align={'center'}>
                <span>Quote {currentQuote?.QuoteNumber}</span>
            </Flex>
        }
        size={drawerSize}
        styles={{
            body: {
                paddingInlineEnd: 0
            },
            content: {
                overflowY: 'hidden'
            }
        }}
    >
        {
            show && !isFetching && (isNew || typeof quote !== 'undefined') && !!others.company && !forceRemount &&
            <ManageQuoteForm
                {...others}
                useTabs
                isNew={isNew}
                quote={quote ?? currentQuote}
                width={fullScreen ? 2000 : `calc(${drawerSize} - 30px)`}
                validateAndCloseCounter={validateAndCloseCounter}
                attemptUpdate={{
                    newItem: others.quote,
                    onUpdateConfirm: (q: any) => {
                        others.setIsNew(false)
                        setCurrentQuote(q)
                    },
                    onUpdateReject: () => { }
                }}
                onClose={() => {
                    others.onClose && others.onClose()
                }}
                fullscreenMode={fullScreen}
                mode={'drawer'}
                onCreated={(item: any, close: any) => {
                    /*if(close) {
                        others.onClose && others.onClose()
                    } else {
                        setCurrentQuote(item)
                    }*/
                    others.onCreated && others.onCreated(item, close)
                }}
                onCreateNew={others.onCreateNew}
                onCopyToQuote={others.onCopyToQuote}
                copyFromQuote={others.copyFromQuote}
            />
        }

        <LoadingOverlay
            visible={isFetching} zIndex={1000} overlayProps={{ radius: "sm", blur: 2 }}
        />


        {
        }
    </ScDrawer>;

}

export default QuoteDrawer
